<template>
    <v-dialog v-model="dialog" max-width="900px" persistent @keydown.esc="chiudi">
        <v-container style="background-color: white;">

            <v-row class="ma-0 pa-0">
                <v-btn icon @click="caricaDati">
                    <v-icon>refresh</v-icon>
                </v-btn>

                <v-btn color="success" @click="apriDialogItem()" small class="mt-1 ml-2">
                    <v-icon left>add</v-icon> Nuovo corso
                </v-btn>

                <v-spacer />
                <v-btn icon @click="chiudi">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-row>

            <v-data-table :headers="headers" :items="corsiAttivi" class="elevation-1" hide-default-footer
                :items-per-page="-1" fixed-header height="60vh" dense no-data-text="Nessun corso presente">
                <template v-slot:item.azioni="{ item }">
                    <v-icon class="mr-2" @click="apriDialogItem(item)">edit</v-icon>
                    <v-icon @click="elimina(item)">delete</v-icon>
                </template>
            </v-data-table>

            <v-dialog v-model="dialogItem" max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ editedItem.corsoId ? 'Modifica' : 'Nuovo' }} corso</span>
                    </v-card-title>

                    <v-card-text>
                        <v-form ref="form">
                            <v-text-field v-model="editedItem.nomeBreve" label="Nome breve" required />
                            <v-textarea v-model="editedItem.titoloCompleto" label="Titolo completo (per l'attestato)"
                                hint="Puo' contenere riferimenti normativi, verra' riportato integralmente sull'attestato"
                                persistent-hint rows="4" required />
                            <v-select v-model="editedItem.tipoCertificazione" :items="tipiCertificazione"
                                label="Tipo di certificato"
                                hint="Decide la cartella del cliente in cui viene copiato l'attestato: FSC/Documenti/Formazione, PEFC/..., FPC/..."
                                persistent-hint />
                        </v-form>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn @click="dialogItem = false">Annulla</v-btn>
                        <v-btn color="primary" @click="salvaCorso">Salva</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-dialog>
</template>

<script>
import { get_corsi, set_corso, delete_corso } from "@/api/api.formazione.js";

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },

    data: () => ({
        corsi: [],
        dialogItem: false,
        tipiCertificazione: ["FSC", "PEFC", "FPC"],
        editedItem: { corsoId: 0, nomeBreve: "", titoloCompleto: "", tipoCertificazione: "", enabled: true },

        headers: [
            { text: "Nome breve", value: "nomeBreve", sortable: false },
            { text: "Certificato", value: "tipoCertificazione", sortable: false },
            { text: "Azioni", value: "azioni", sortable: false },
        ],
    }),

    computed: {
        // I corsi eliminati (Enabled = 0) restano nel database solo perche' hanno edizioni passate: qui non compaiono.
        corsiAttivi() {
            return this.corsi.filter((c) => c.enabled);
        },
    },

    methods: {
        async caricaDati() {
            const res = await get_corsi();
            this.corsi = res.data;
        },

        apriDialogItem(item = null) {
            this.editedItem = item ? { ...item } : { corsoId: 0, nomeBreve: "", titoloCompleto: "", tipoCertificazione: "", enabled: true };
            this.dialogItem = true;
        },

        async salvaCorso() {
            if (!this.editedItem.nomeBreve || !this.editedItem.titoloCompleto) {
                this.$toast.alert("Nome breve e titolo completo sono obbligatori");
                return;
            }
            if (!this.editedItem.tipoCertificazione) {
                this.$toast.alert("Seleziona il tipo di certificato");
                return;
            }

            const res = await set_corso(this.editedItem);
            if (!isNaN(res.data)) {
                this.$toast.info("Corso salvato con successo!");
                this.dialogItem = false;
                await this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async elimina(item) {
            let confirm = await this.$confirm.open(
                "Elimina corso",
                "Eliminare il corso <b>" + item.nomeBreve + "</b>? Se ha gia' delle edizioni queste restano visibili (con certificati scaricabili), ma il corso non sara' piu' selezionabile per le nuove."
            );
            if (!confirm) return;

            const res = await delete_corso(item.corsoId);
            if (res.data === "OK") {
                await this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        chiudi() {
            this.$emit("close");
        },
    },

    watch: {
        dialog(newVal) {
            if (newVal) this.caricaDati();
        },
    },
};
</script>
